export interface IAppointment {
    id: number;
    scheduledDate: string;
    timeSlot: EAppointmentSlot;
    installationType: EInstallationType;
    status: EAppointmentStatus;
}

export enum EInstallationType {
    TECH = "TECH",
    SELF = "SELF",
    FULL = "FULL",
}

export enum EAppointmentStatus {
    LOCKED = "LOCKED",
    VALIDATED = "VALIDATED",
    AWAITING_RESCHEDULE = "AWAITING_RESCHEDULE",
}

export enum EAppointmentSlot {
    AD = "AD",
    AM = "AM",
    PM = "PM",
}
